import { GovField } from "@publicMirage/components/govReact/GovField";
import { ErrorText, FormGroup, H3, InsetText, LabelText } from "govuk-react";
import React, { memo } from "react";
import { useForm } from "../hooks/formContext";
import { PrePpWlTypeOfOtherDevelopmentTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";

export const OtherType = memo(() => {
    const { toFieldProps, formState } = useForm();
    const { developmentScale } = formState;
    const errorMsg = developmentScale.errorMsg;

    return (
        <>
            <H3>Type D: Any other development</H3>
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Scale of development</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfOtherDevelopmentTypes.VARIATION_OR_REMOVAL_OF_CONDITION)}
                    label="Variation or removal of a condition"
                />
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfOtherDevelopmentTypes.ADVERTISEMENTS)} label="Advertisements" />
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfOtherDevelopmentTypes.NON_HOUSEHOLDER_LISTED_BUILDING_CONSENT)}
                    label="Non-householder listed building consent"
                />
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfOtherDevelopmentTypes.OTHER)} label="Other" />
            </FormGroup>
            {developmentScale.value === PrePpWlTypeOfOtherDevelopmentTypes.OTHER ? (
                <>
                    <InsetText>Please contact the team to discuss pricing</InsetText>
                    <GovField {...toFieldProps("otherDevelopmentDescription", "TEXTAREA")} />
                </>
            ) : null}
        </>
    );
});
